export default {
  title: "Attività",
  description: "Gestisci le tue attività del matrimonio",
  taskList: "Lista delle attività",
  addTask: "Aggiungi attività",
  editTask: "Modifica attività",
  deleteTask: "Elimina attività",
  taskTitle: "Titolo dell'attività",
  taskDescription: "Descrizione dell'attività",
  dueDate: "Data di scadenza",
  priorityLabel: "Priorità",
  category: "Categoria",
  assignedTo: "Assegnato a",
  notes: "Note",
  subtasks: "Sottoattività",
  addSubtask: "Aggiungi sottoattività",
  noTasks: "Nessuna attività trovata",
  addFirstTask: "Aggiungi la tua prima attività",
  taskDetails: "Dettagli attività",
  save: "Salva",
  cancel: "Annulla",
  delete: "Elimina",
  edit: "Modifica",
  complete: "Completa",
  incomplete: "Incompleta",
  confirmDelete: "Sei sicuro di voler eliminare questa attività?",
  confirmDeleteTask: "Sei sicuro di voler eliminare questa attività?",
  taskAdded: "Attività aggiunta con successo",
  taskUpdated: "Attività aggiornata con successo",
  taskDeleted: "Attività eliminata con successo",
  taskCreated: "Attività creata con successo",
  taskCompleted: "Attività completata con successo",
  taskUncompleted: "Attività segnata come non completata",
  totalTasks: "{{count}} attività",
  pending: "{{count}} in attesa",
  completed: "{{count}} completate",
  search: "Cerca attività",
  "tasks.dueDate": "Data di scadenza",

  view: {
    list: "Lista",
    kanban: "Kanban",
    boardView: "Vista tabella",
    calendarView: "Vista calendario",
    listView: "Vista lista"
  },

  priority: {
    low: "Bassa",
    medium: "Media",
    high: "Alta",
    urgent: "Urgente"
  },

  status: {
    todo: "Da fare",
    pending: "In attesa",
    inProgress: "In corso",
    in_progress: "In corso",
    completed: "Completata",
    cancelled: "Annullata",
    done: "Fatto",
    overdue: "In ritardo"
  },

  statuses: {
    pending: "In attesa",
    in_progress: "In corso",
    completed: "Completata",
    cancelled: "Annullata"
  },

  categories: {
    planning: "Pianificazione",
    venue: "Luogo",
    catering: "Catering",
    flowers: "Fiori",
    photography: "Fotografia",
    music: "Musica",
    attire: "Abbigliamento",
    invitations: "Inviti",
    transportation: "Trasporto",
    decoration: "Decorazione",
    legal: "Legale",
    beauty: "Bellezza",
    other: "Altro",
    ceremony: "Cerimonia",
    reception: "Ricevimento",
    vendors: "Fornitori",
    guests: "Ospiti",
    honeymoon: "Luna di miele"
  },

  filters: {
    title: "Filtri",
    all: "Tutte le attività",
    pending: "In attesa",
    completed: "Completate",
    overdue: "In ritardo",
    today: "Per oggi",
    thisWeek: "Questa settimana",
    thisMonth: "Questo mese",
    status: "Stato",
    category: "Categoria",
    dueDate: "Data di scadenza",
    priority: "Priorità",
    priorityLabel: "Priorità",
    search: "Cerca un'attività",
    sortBy: "Ordina per",
    clear: "Cancella filtri",
    reset: "Reimposta",
    assignee: "Assegnato a",
    apply: "Applica",
    previous: "Precedente",
    next: "Successivo",
    options: {
      title: "Titolo",
      dueDate: "Data di scadenza",
      priority: "Priorità",
      status: "Stato"
    }
  },

  sort: {
    dueDate: "Data di scadenza",
    priorityLabel: "Priorità",
    status: "Stato",
    title: "Titolo",
    created: "Data di creazione"
  },

  dueDateWarning: "La data di scadenza si avvicina",
  overdue: "In ritardo",
  dueToday: "Per oggi",
  dueTomorrow: "Per domani",
  dueThisWeek: "Per questa settimana",
  dueNextWeek: "Per la prossima settimana",
  dueThisMonth: "Per questo mese",
  dueNextMonth: "Per il prossimo mese",
  noDueDate: "Nessuna data di scadenza",
  progress: "Progresso",
  completionRate: "Tasso di completamento",
  completedTasks: "Attività completate",
  pendingTasks: "Attività in attesa",
  overdueTasks: "Attività in ritardo",
  taskProgress: "Progresso attività",
  milestones: "Pietre miliari",
  createMilestone: "Crea pietra miliare",
  milestoneTitle: "Titolo pietra miliare",
  milestoneDate: "Data pietra miliare",
  milestoneDescription: "Descrizione pietra miliare",
  milestoneAdded: "Pietra miliare aggiunta con successo",
  milestoneUpdated: "Pietra miliare aggiornata con successo",
  milestoneDeleted: "Pietra miliare eliminata con successo",
  timeline: "Cronologia",
  ganttChart: "Diagramma di Gantt",
  searchPlaceholder: "Cerca per titolo o descrizione",
  noResults: "Nessuna attività corrisponde alla tua ricerca",
  clearSearch: "Cancella ricerca",
  export: "Esporta",
  import: "Importa",
  exportTasks: "Esporta attività",
  importTasks: "Importa attività",
  template: "Modello",
  useTemplate: "Usa un modello",
  weddingPlanningTemplate: "Modello pianificazione matrimonio",
  customTemplate: "Modello personalizzato",
  templateApplied: "Modello applicato con successo",
  bulkActions: "Azioni di massa",
  selectAll: "Seleziona tutto",
  deselectAll: "Deseleziona tutto",
  markCompleted: "Segna come completato",
  markPending: "Segna come in attesa",
  changeCategory: "Cambia categoria",
  changePriority: "Cambia priorità",
  bulkDelete: "Eliminazione di massa",
  selectedTasks: "{{count}} attività selezionate",
  bulkUpdateSuccess: "{{count}} attività aggiornate con successo",
  bulkDeleteSuccess: "{{count}} attività eliminate con successo",
  confirmBulkDelete: "Sei sicuro di voler eliminare {{count}} attività?",
  dependencies: "Dipendenze",
  addDependency: "Aggiungi dipendenza",
  dependsOn: "Dipende da",
  blockedBy: "Bloccato da",
  blocks: "Blocca",
  noDependencies: "Nessuna dipendenza",
  attachments: "Allegati",
  addAttachment: "Aggiungi allegato",
  uploadFile: "Carica file",
  downloadFile: "Scarica file",
  deleteFile: "Elimina file",
  fileUploaded: "File caricato con successo",
  fileDeleted: "File eliminato con successo",
  comments: "Commenti",
  addComment: "Aggiungi commento",
  commentPlaceholder: "Aggiungi un commento...",
  commentAdded: "Commento aggiunto con successo",
  commentUpdated: "Commento aggiornato con successo",
  commentDeleted: "Commento eliminato con successo",
  noComments: "Ancora nessun commento",
  notifications: "Notifiche",
  reminders: "Promemoria",
  setReminder: "Imposta promemoria",
  reminderTime: "Ora promemoria",
  reminderSet: "Promemoria impostato con successo",
  reminderDeleted: "Promemoria eliminato con successo",
  emailNotifications: "Notifiche email",
  pushNotifications: "Notifiche push",
  recurring: "Ricorrente",
  recurringTask: "Attività ricorrente",
  recurrencePattern: "Modello ricorrenza",
  daily: "Giornaliero",
  weekly: "Settimanale",
  monthly: "Mensile",
  yearly: "Annuale",
  custom: "Personalizzato",
  endDate: "Data di fine",
  occurrences: "Occorrenze",
  recurringTaskCreated: "Attività ricorrente creata con successo",
  analytics: "Analitica",
  productivity: "Produttività",
  timeTracking: "Tracciamento tempo",
  startTimer: "Avvia timer",
  stopTimer: "Ferma timer",
  timeSpent: "Tempo impiegato",
  estimatedTime: "Tempo stimato",
  actualTime: "Tempo effettivo",
  efficiency: "Efficienza",
  taskVelocity: "Velocità attività",
  burndownChart: "Grafico burndown",
  velocityChart: "Grafico velocità",

  form: {
    title: "Titolo dell'attività",
    description: "Descrizione dell'attività",
    category: "Categoria",
    priority: "Priorità",
    status: "Stato",
    dueDate: "Data di scadenza",
    new: "Nuova attività",
    edit: "Modifica attività",
    titlePlaceholder: "Titolo dell'attività",
    descriptionPlaceholder: "Descrizione dell'attività",
    dueDatePlaceholder: "Data di scadenza",
    categoryPlaceholder: "Categoria",
    priorityPlaceholder: "Priorità",
    statusPlaceholder: "Stato",
    assignedTo: "Assegnato a",
    assignedToPlaceholder: "Responsabile",
    notes: "Note",
    notesPlaceholder: "Note aggiuntive",
    submit: "Salva",
    cancel: "Annulla",
    name: "Nome",
    assignee: "Assegnato a",
    confirmCancel: "Sei sicuro di voler annullare? Le modifiche non salvate andranno perse.",
    errors: {
      titleRequired: "Il titolo è obbligatorio",
      descriptionRequired: "La descrizione è obbligatoria",
      submitFailed: "Errore durante il salvataggio dell'attività",
      titleMinLength: "Il titolo deve contenere almeno 3 caratteri",
      statusRequired: "Lo stato è obbligatorio",
      priorityRequired: "La priorità è obbligatoria",
      categoryRequired: "La categoria è obbligatoria",
      dueDateRequired: "La data di scadenza è obbligatoria"
    }
  },

  actions: {
    edit: "Modifica",
    delete: "Elimina",
    complete: "Completa",
    moveTask: "Sposta attività"
  },

  errors: {
    moveTask: "Errore durante lo spostamento dell'attività",
    loadFailed: "Errore durante il caricamento delle attività",
    addFailed: "Errore durante l'aggiunta dell'attività",
    updateFailed: "Errore durante l'aggiornamento dell'attività",
    deleteFailed: "Errore durante l'eliminazione dell'attività",
    submit: "Errore durante l'invio dell'attività"
  },

  messages: {
    createSuccess: "Attività aggiunta con successo",
    updateSuccess: "Attività aggiornata con successo",
    deleteSuccess: "Attività eliminata con successo",
    deleteConfirm: "Sei sicuro di voler eliminare questa attività?",
    error: "Si è verificato un errore"
  },

  modal: {
    title: "Attività",
    edit: "Modifica attività",
    delete: "Elimina attività",
    confirmDelete: "Sei sicuro di voler eliminare questa attività?"
  },

  sharing: {
    title: "Condividi lista attività",
    share: "Condividi",
    success: "Lista attività condivisa con successo",
    readOnly: "Sola lettura",
    edit: "Modifica",
    defaultMessage: "Ho condiviso un'attività con te",
    recipientEmail: "Email destinatario",
    emailPlaceholder: "Inserisci l'email del destinatario",
    recipientName: "Nome destinatario",
    namePlaceholder: "Inserisci il nome del destinatario",
    message: "Messaggio",
    messagePlaceholder: "Inserisci il tuo messaggio",
    accessLevel: "Livello di accesso"
  },

  demoTasks: {
    bookVenue: {
      title: "Prenotare la location",
      description: "Trovare e prenotare la location ideale per la cerimonia e il ricevimento"
    },
    orderInvitations: {
      title: "Ordinare gli inviti",
      description: "Scegliere e ordinare gli inviti per gli ospiti"
    },
    bookCaterer: {
      title: "Prenotare il catering",
      description: "Selezionare e prenotare il catering per il pranzo di nozze"
    },
    chooseDress: {
      title: "Scegliere l'abito",
      description: "Trovare l'abito da sposa perfetto"
    },
    bookPhotographer: {
      title: "Prenotare il fotografo",
      description: "Selezionare e prenotare il fotografo per immortalare il tuo giorno"
    },
    chooseRings: {
      title: "Scegliere le fedi",
      description: "Trovare le fedi perfette per la vostra coppia"
    }
  }
};
